export default {"src":"/_next/static/media/trust_logo.34d991c8.svg","height":27,"width":99,"blurWidth":0,"blurHeight":0};